// https://www.npmjs.com/package/@nuxtjs/svg
import Vue from 'vue'
import component from './component.vue'
Vue.component('svgicon', component)
